import { createBrowserRouter } from 'react-router-dom';
import WithLazyLoading from '../components/shared/WithLazyLoading';
import App from '../App';

const Accueil = WithLazyLoading(() => import('../pages/accueil/Accueil'));
const About = WithLazyLoading(() => import('../pages/About'));
const Contact = WithLazyLoading(() => import('../pages/contact/Contact'));
const Historique = WithLazyLoading(() => import('../pages/Historique'));
const Portfolio = WithLazyLoading(() => import('../pages/Portfolio'));
const NotFound = WithLazyLoading(() => import('../components/notfound/NotFound'));

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <NotFound />,
    children: [
      {
        path: '',
        element: <Accueil />,
      },
      {
        path: 'about',
        element: <About />,
      },
      {
        path: 'historique',
        element: <Historique />,
      },
      {
        path: 'portfolio',
        element: <Portfolio />,
      },
      {
        path: 'contact',
        element: <Contact />,
      },
    ],
  },
]);

export default router;
